import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  {
    documentData,
    userid,
    username,
    callbackUrl,
  }: Boundaries["retrieveDocumentEditionToken"]["request"],
): State {
  const stateIndex = state.findIndex(
    (result) => result.documentData?.key === documentData?.key,
  );

  return stateIndex !== -1
    ? [
        ...state.slice(0, stateIndex),
        {
          ...state[stateIndex],
          request: setRequestStateToPending(),
        },
        ...state.slice(stateIndex + 1),
      ]
    : [
        ...state,
        {
          token: "",
          documentData,
          userid,
          username,
          callbackUrl,
          request: setRequestStateToPending(),
        },
      ];
}

function handleSuccess(
  state: State,
  {
    token,
    documentData,
  }: Boundaries["retrieveDocumentEditionToken"]["success"],
): State {
  return state.map((item) =>
    item.documentData?.key === documentData?.key
      ? {
          ...item,
          token,
          request: setRequestStateToSuccess(),
        }
      : item,
  );
}

function handleFailure(
  state: State,
  { documentData }: Boundaries["retrieveDocumentEditionToken"]["failure"],
): State {
  return state.map((item) =>
    item.documentData?.key === documentData?.key
      ? { ...item, request: setRequestStateToFailure() }
      : item,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveDocumentEditionTokenRequested]: handleRequest,
    [events.retrieveDocumentEditionTokenSucceeded]: handleSuccess,
    [events.retrieveDocumentEditionTokenFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
